/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import GrantProgramsIcon from 'icons/GrantProgramsIcon';

const messages = defineMessages({
  title: {id: 'navigation.grants.programs'},
});

const ProgramsItem = () => (
  <RouteLinkItem
    iconBefore={GrantProgramsIcon}
    route="midas/grants/programs"
    title={messages.title}
  />
);

export default ProgramsItem;
